import axios from "axios";

const disabledCache = {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': 0
}


const getDataJsonFile = () => {
    return axios.get('/data/pilot-ptt-rzeszow-config-v2.json', { headers: disabledCache }).then((res) => {
        return res.data
    });
}

const getDataJsonFileByName = (fileName) => {
    return axios.get(`/data/${fileName}.json`, { headers: disabledCache }).then((res) => {
        return res.data
    });
}

export const DataService = {
    getDataJsonFile,
    getDataJsonFileByName
}
